import { FilterPill } from './FilterPill';

interface FollowablePillProps {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  isFollowed: boolean;
  onFollowToggle: () => void;
  isAuthenticated: boolean;
  className?: string;
}

export function FollowablePill({
  label,
  isSelected,
  onClick,
  isFollowed,
  onFollowToggle,
  isAuthenticated,
  className,
}: FollowablePillProps) {
  return (
    <span
      className={`group/pill relative inline-flex items-center ${
        className ?? ''
      }`}
    >
      <FilterPill label={label} isSelected={isSelected} onClick={onClick} />
      {isAuthenticated && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onFollowToggle();
          }}
          className={`absolute -top-3 -right-3 inline-flex items-center justify-center w-7 h-7 rounded-full transition-all duration-150 ${
            isFollowed
              ? 'text-primary opacity-100 scale-100 drop-shadow-[0_0_3px_rgba(255,255,255,0.9)] dark:drop-shadow-[0_0_3px_rgba(0,0,0,0.9)]'
              : 'text-neutral-400 dark:text-neutral-500 opacity-0 scale-75 group-hover/pill:opacity-100 group-hover/pill:scale-100 focus:opacity-100 focus:scale-100'
          }`}
          aria-label={isFollowed ? `Unfollow ${label}` : `Follow ${label}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill={isFollowed ? 'currentColor' : 'none'}
            stroke="currentColor"
            strokeWidth={2}
            className="w-[18px] h-[18px]"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
            />
          </svg>
        </button>
      )}
    </span>
  );
}
